import script from "./CategoryGroupPop.vue?vue&type=script&lang=ts&setup=true"
export * from "./CategoryGroupPop.vue?vue&type=script&lang=ts&setup=true"

import "./CategoryGroupPop.vue?vue&type=style&index=0&id=5b93ad35&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b93ad35"]])

export default __exports__